import { Core } from "@faire/design-tokens";

import { ButtonVariantTheme } from "../Button/types";

import { IIconButtonTheme } from "./types";

const primaryStyle: ButtonVariantTheme = {
  active: () => ({
    "background-color": Core.surface.enabled,
    color: Core.icon.inverse,
  }),
  base: () => ({
    "background-color": Core.surface.default,
    color: Core.icon.inverse,
  }),
  disabled: () => ({
    "background-color": Core.surface.disabled,
    color: Core.icon.disabled,
  }),
  focus: () => ({
    "background-color": Core.surface.hover,
    color: Core.icon.inverse,
  }),
  hover: () => ({
    "background-color": Core.surface.hover,
    color: Core.icon.inverse,
  }),
  loading: () => ({
    "background-color": Core.surface.default,
    color: Core.icon.inverse,
  }),
};

const secondaryStyle: ButtonVariantTheme = {
  active: () => ({
    "background-color": Core.surface.inverse,
    border: `1px solid ${Core.border.enabled}`,
    color: Core.icon.enabled,
  }),
  base: () => ({
    "background-color": Core.surface.inverse,
    border: `1px solid ${Core.border.muted}`,
    color: Core.icon.default,
  }),
  disabled: () => ({
    "background-color": Core.surface.subdued,
    border: `1px solid ${Core.border.disabled}`,
    color: Core.icon.disabled,
  }),
  focus: () => ({
    "background-color": Core.surface.inverse,
    border: `1px solid ${Core.border.hover}`,
    color: Core.icon.hover,
  }),
  hover: () => ({
    "background-color": Core.surface.inverse,
    border: `1px solid ${Core.border.hover}`,
    color: Core.icon.hover,
  }),
  loading: () => ({
    "background-color": Core.surface.inverse,
    border: `1px solid ${Core.border.default}`,
    color: Core.icon.default,
  }),
};

const tertiaryStyle: ButtonVariantTheme = {
  active: () => ({
    "background-color": Core.surface.subdued,
    color: Core.icon.enabled,
  }),
  base: () => ({
    "background-color": "transparent",
    color: Core.icon.default,
  }),
  disabled: () => ({
    "background-color": "transparent",
    color: Core.border.disabled,
  }),
  focus: () => ({
    "background-color": Core.surface.subdued,
    color: Core.icon.hover,
  }),
  hover: () => ({
    "background-color": Core.surface.subdued,
    color: Core.icon.hover,
  }),
  loading: () => ({
    "background-color": "transparent",
    color: Core.icon.default,
  }),
};

export const iconWrapperTheme: IIconButtonTheme = {
  primary: primaryStyle,
  secondary: secondaryStyle,
  tertiary: tertiaryStyle,
};
